import React from 'react';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

import { colors } from '@/constants/theme';
import { getMapProps } from '@/utils/map';

import { YandexMapProps } from './types';

function YandexMap({ markers }: YandexMapProps) {
  if (!markers || markers.length === 0) {
    return null;
  }

  const mapProps = getMapProps(
    markers.map(({ latitude, longitude }) => ({
      latitude,
      longitude,
    }))
  );

  return (
    <YMaps
      query={{
        apikey: process.env.NEXT_PUBLIC_API_KEY_YANDEX_MAP,
      }}
    >
      <Map
        style={{ width: '100%', height: '100%' }}
        defaultState={{
          center: [mapProps.center.lat, mapProps.center.lng],
          zoom: mapProps.zoom,
        }}
        modules={['geoObject.addon.balloon']}
      >
        {markers.map(({ latitude, longitude, name, address }, index) => (
          <Placemark
            key={index}
            geometry={[latitude, longitude]}
            properties={{
              balloonContent:
                '<div>' +
                `<b>${name}</b><br />` +
                `<p>${address}</p>` +
                '</div>',
            }}
            options={{ iconColor: colors.main }}
          />
        ))}
      </Map>
    </YMaps>
  );
}

export default YandexMap;
